﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿import React, { useState, useEffect, useMemo } from 'react';
import { Card, Typography, Row, Col, Input, Button, Tag, Space, Empty, Divider, Popconfirm, Modal, Collapse, Flex, Tabs, Badge, Tooltip, App } from 'antd';
import { PlusOutlined, DeleteOutlined, SaveOutlined, ReloadOutlined, EditOutlined, FolderOpenOutlined, PlusSquareOutlined, MinusSquareOutlined, AppstoreOutlined, FilterOutlined, HomeOutlined, DownOutlined, UpOutlined, CloudSyncOutlined } from '@ant-design/icons';
import { categoryService, productService } from '../services/api';

const { Title, Text } = Typography;

const FACET_DEFS = [
  { k: 'brand',           label: 'Marque' },
  { k: 'system',          label: 'Système / Solution' },
  { k: 'typeGaz',         label: 'Type de gaz' },
  { k: 'typeDetecteur',   label: 'Type de détecteur' },
  { k: 'usage',           label: 'Usage' },
  { k: 'connectivity',    label: 'Connectivité / Connexion' },
  { k: 'phase',           label: 'Phase' },
  { k: 'puissance',       label: 'Puissance' },
  { k: 'norme',           label: 'Norme' },
  { k: 'solution',        label: 'Solution' },
  { k: 'equipement',      label: 'Équipement' },
  { k: 'categorie',       label: 'Catégorie' },
  { k: 'type',            label: 'Type' },
  { k: 'resolution',      label: 'Résolution' },
  { k: 'technologie',     label: 'Technologie' },
  { k: 'debit',           label: 'Débit' },
  { k: 'fonctionnalite',  label: 'Fonctionnalité (multi)' }
];
const FACET_BY_KEY = FACET_DEFS.reduce((acc, f) => (acc[f.k] = f, acc), {});

const STORAGE_KEY = 'domoelec:facetTemplates';

const DEFAULT_FAMILY_TREE = [
  { name: 'ÉCLAIRAGE DE SÉCURITÉ', children: [
    { name: 'ÉCLAIRAGE AUTONOME', children: [{ name: "BLOC D'AMBIANCE" }, { name: "BLOC D'ÉVACUATION" }, { name: 'ACCESSOIRES' }] },
    { name: 'ÉCLAIRAGE SUR SOURCE', children: [
      { name: 'ADRESSABLE', children: [{ name: 'SOURCE CENTRALE' }, { name: 'LUMINAIRE' }] },
      { name: 'CONVENTIONNEL', children: [{ name: 'SOURCE CENTRALE' }, { name: "LUMINAIRE D'ÉCLAIRAGE" }] }
    ]}
  ]},
  { name: 'ONDULEUR', children: [
    { name: 'PHASE', children: [{ name: 'THREE-PHASE' }, { name: 'SINGLE-PHASE' }] },
    { name: 'PUISSANCE', children: [{ name: '0-5 KVA' }, { name: '6-15 KVA' }, { name: '20-100' }] }
  ]},
  { name: 'DÉTECTION INCENDIE', children: [
    { name: 'MARQUE', children: [{ name: 'NUGELEC' }, { name: 'COOPER' }] },
    { name: 'NORME', children: [{ name: 'NF' }, { name: 'EN' }] },
    { name: 'SOLUTION', children: [{ name: 'CONVENTIONNEL' }, { name: 'ADRESSABLE' }] },
    { name: 'ÉQUIPEMENTS', children: [{ name: 'CENTRALE' }, { name: 'AES' }, { name: 'PÉRIPHÉRIQUE' }, { name: 'SIRÈNES' }, { name: 'AUTRES' }] }
  ]},
  { name: "CONTRÔLE D'ACCÈS & POINTAGE", children: [
    { name: 'MARQUE', children: [{ name: 'HIKVISION' }, { name: 'ZKTECO' }] },
    { name: 'CATÉGORIE', children: [
      { name: "CONTRÔLE D'ACCÈS", children: [{ name: 'CONTRÔLEUR' }, { name: 'TERMINAL' }] },
      { name: 'GESTION DE TEMPS & POINTAGE', children: [{ name: 'POINTEUSE' }, { name: 'LOGICIEL' }] },
      { name: "CONTRÔLE D'ENTRÉE", children: [{ name: 'TOURNIQUET' }, { name: 'BARRIÈRE DE PARKING' }] },
      { name: "ACCESSOIRE D'ACCÈS" }
    ]}
  ]},
  { name: 'VIDÉOSURVEILLANCE', children: [
    { name: 'MARQUE', children: [{ name: 'HIKVISION' }] },
    { name: 'CATÉGORIE', children: [{ name: 'CAMÉRA IP' }, { name: 'CAMÉRA PTZ' }, { name: 'ENREGISTREURS VIDÉO RÉSEAU NVR' }] }
  ]},
  { name: 'INTRUSION', children: [
    { name: 'MARQUE', children: [{ name: 'TECNOALARME' }, { name: 'HIKVISION' }] },
    { name: 'CONNEXION', children: [{ name: 'FILAIRE' }, { name: 'SANS FIL' }] },
    { name: 'CATÉGORIE', children: [{ name: 'CENTRALE INTRUSION' }, { name: 'DÉTECTEURS' }, { name: 'SIRÈNES' }, { name: 'ACCESSOIRES' }] }
  ]},
  { name: 'DOMOTIQUE / GRMS', children: [
    { name: 'MARQUE', children: [{ name: 'ZENNIO' }, { name: 'HDL' }, { name: 'COMELIT' }] },
    { name: 'SOLUTION', children: [{ name: 'KNX' }, { name: 'BUS' }, { name: 'SANS FILS' }, { name: 'AUTRES' }] },
    { name: 'CATÉGORIE', children: [{ name: 'CAPTEURS' }, { name: 'INTERFACES AUDIO/VIDÉO' }, { name: 'ACTIONNEURS' }, { name: 'CONTRÔLEURS' }, { name: 'PASSERELLES' }] },
    { name: 'FONCTIONNALITÉ', children: [{ name: "GESTION DE L'ÉCLAIRAGE" }, { name: 'CONTRÔLE DE LA CLIMATISATION' }, { name: 'AUTOMATISATION DE VOLETS' }, { name: 'INTÉGRATION AUDIO/VIDÉO' }] }
  ]},
  { name: 'SONORISATION', children: [
    { name: 'MARQUE', children: [{ name: 'BOSE' }, { name: 'DSPPA' }] },
    { name: 'CATÉGORIE', children: [{ name: 'ENCEINTES PASSIVES' }, { name: 'ENCEINTES ACTIVES' }, { name: 'AMPLIFICATEURS' }, { name: 'ACCESSOIRES AUDIO' }] },
    { name: 'USAGE', children: [{ name: 'INTÉRIEUR' }, { name: 'EXTÉRIEUR' }] },
    { name: 'CONNECTIVITÉ', children: [{ name: 'FILAIRE' }, { name: 'SANS FIL' }] }
  ]},
  { name: 'EXTINCTION', children: [
    { name: 'MARQUE', children: [{ name: 'AGUILERA' }] },
    { name: 'TYPE DE GAZ', children: [{ name: 'FE-13' }, { name: 'HFC-227EA' }, { name: 'NOVEC TM' }, { name: 'CO2' }] },
    { name: 'CATÉGORIE', children: [{ name: 'CENTRALE' }, { name: 'DÉTECTEURS' }, { name: 'DÉCLENCHEURS' }, { name: 'SIRÈNES' }] }
  ]},
  { name: 'DÉTECTION DE GAZ', children: [
    { name: 'MARQUE', children: [{ name: 'SENSITRON' }] },
    { name: 'TYPE DE GAZ', children: [{ name: 'GAZ INFLAMMABLES' }, { name: 'GAZ TOXIQUES' }, { name: 'MULTI GAZ' }] },
    { name: 'TYPE DE DÉTECTEURS', children: [{ name: 'DÉTECTEUR FIXE' }, { name: 'DÉTECTEUR PORTABLE' }, { name: 'DÉTECTEURS POUR PARKING' }] }
  ]}
];

const DEFAULT_TEMPLATES = {
  brand: ['HIKVISION', 'NUGELEC', 'COOPER', 'ZKTECO', 'TECNOALARME', 'ZENNIO', 'HDL', 'COMELIT', 'BOSE', 'DSPPA', 'AGUILERA', 'SENSITRON'],
  phase: ['SINGLE-PHASE', 'THREE-PHASE'],
  puissance: ['0-5 KVA', '6-15 KVA', '20-100'],
  norme: ['NF', 'EN', 'CE', 'ROHS'],
  solution: ['KNX', 'BUS', 'SANS FILS', 'ADRESSABLE', 'CONVENTIONNEL', 'AUTRES'],
  usage: ['INTÉRIEUR', 'EXTÉRIEUR'],
  connectivity: ['FILAIRE', 'SANS FIL', 'WIFI', 'BLUETOOTH', 'POE'],
  typeGaz: ['GAZ INFLAMMABLES', 'GAZ TOXIQUES', 'MULTI GAZ', 'FE-13', 'HFC-227EA', 'NOVEC TM', 'CO2'],
  typeDetecteur: ['DÉTECTEUR FIXE', 'DÉTECTEUR PORTABLE', 'DÉTECTEURS POUR PARKING'],
  technologie: ['IP', 'ANALOGIQUE', 'HD-TVI', 'AHD', 'CVI'],
  resolution: ['1080P', '4MP', '5MP', '4K UHD', '8MP'],
  debit: ['1 Gbps', '100 Mbps', '10 Gbps']
};

const normalizeAdminName = value =>
  String(value || '')
    .trim().toUpperCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[’'`]/g, "'").replace(/\s+/g, ' ');

const cloneTree = t => JSON.parse(JSON.stringify(t));

const genNodeId = () =>
  'n_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8);

const migrateNodeWithIds = node => {
  if (!node || typeof node !== 'object') return node;
  const next = { ...node };
  if (!next.id) next.id = genNodeId();
  if (next.children && Array.isArray(next.children)) {
    next.children = next.children.map(migrateNodeWithIds);
  } else {
    next.children = [];
  }
  return next;
};
const migrateTreeWithIds = tree => (Array.isArray(tree) ? tree.map(migrateNodeWithIds) : []);

const findInTreeById = (nodes, targetId) => {
  if (!Array.isArray(nodes) || !targetId) return null;
  for (let i = 0; i < nodes.length; i++) {
    const n = nodes[i];
    if (n.id === targetId) return { node: n, parent: nodes, index: i };
    if (Array.isArray(n.children)) {
      const sub = findInTreeById(n.children, targetId);
      if (sub) return sub;
    }
  }
  return null;
};

const loadAll = () => {
  const ids = arr => migrateTreeWithIds(Array.isArray(arr) ? cloneTree(arr) : []);
  const mergeWithDefaults = parsed => ({
    templates: { ...cloneTree(DEFAULT_TEMPLATES), ...((parsed && parsed.templates) || {}) },
    familyTree: (parsed && Array.isArray(parsed.familyTree) && parsed.familyTree.length > 0)
      ? ids(parsed.familyTree)
      : ids(DEFAULT_FAMILY_TREE)
  });
  try {
    // 1) RAM globale (fonctionne même si Tracking Prevention bloque tout storage)
    if (window.__domoelecFiltersStore && typeof window.__domoelecFiltersStore === 'object') {
      return mergeWithDefaults(window.__domoelecFiltersStore);
    }
    // 2) sessionStorage (moins sujet au Tracking Prevention)
    let raw = null;
    try { raw = sessionStorage.getItem(STORAGE_KEY); } catch { raw = null; }
    if (raw) return mergeWithDefaults(JSON.parse(raw) || {});
    // 3) localStorage (fallback si autorisé)
    try { raw = localStorage.getItem(STORAGE_KEY); } catch { raw = null; }
    if (raw) return mergeWithDefaults(JSON.parse(raw) || {});
    return mergeWithDefaults({});
  } catch {
    return mergeWithDefaults({});
  }
};

const countLeaves = node => {
  if (!Array.isArray(node.children) || node.children.length === 0) return 1;
  return node.children.reduce((sum, c) => sum + countLeaves(c), 0);
};
const countDirectChildren = node => (Array.isArray(node.children) ? node.children.length : 0);

// ========== SYNC BDD -> STORAGE helpers ==========
// Construit un arbre hiérarchique (parents/enfants) depuis la liste plate API categories
const buildTreeFromFlatCategories = (flatCats = []) => {
  if (!Array.isArray(flatCats) || flatCats.length === 0) return [];
  const byId = new Map();
  flatCats.forEach(c => {
    byId.set(String(c.id), {
      id: String(c.id),
      name: String(c.name || '').trim(),
      slug: c.slug || null,
      parentCategoryId: c.parentCategoryId || c.parentCategory?.id || null,
      sortOrder: Number(c.sortOrder) || 0,
      isActive: c.isActive !== false,
      children: []
    });
  });
  const roots = [];
  byId.forEach(node => {
    const pid = node.parentCategoryId ? String(node.parentCategoryId) : null;
    if (pid != null && byId.has(pid)) byId.get(pid).children.push(node);
    else roots.push(node);
  });
  const sortWalk = arr => {
    arr.sort((a, b) => (Number(a.sortOrder) || 0) - (Number(b.sortOrder) || 0));
    arr.forEach(n => { if (Array.isArray(n.children) && n.children.length) sortWalk(n.children); });
  };
  sortWalk(roots);
  return roots;
};

// Merge backend tree INTO storage tree (priorité backend > default)
// — NE SUPPRIME PAS les nœuds ajoutés manuellement (custom) qui n'existent pas en BDD
// — AJOUTE & MET À JOUR ceux qui viennent d'être importés/créés
const mergeBackendIntoStorageTree = (storageRoots = [], backendRoots = []) => {
  const un = v => normalizeAdminName(v);
  const backendByNormalizedName = new Map(); // Map<normalizedParentPath, List<nodes>>
  const walkBackend = (nodes, trail = []) => {
    (nodes || []).forEach(n => {
      const trailNow = [...trail, un(n?.name)];
      const key = trailNow.join('|');
      if (!backendByNormalizedName.has(key)) backendByNormalizedName.set(key, []);
      backendByNormalizedName.get(key).push({ ...n, _path: trailNow });
      if (n.children?.length) walkBackend(n.children, trailNow);
    });
  };
  walkBackend(backendRoots || []);

  const outByName = new Map(); // Map<nameNormalized, node>
  // 1) Parcours storage existant: on garde tout (custom inclus), mais si un match backend → on merge children
  const walkStorage = (nodes, trail = []) => {
    (nodes || []).forEach(n => {
      if (!n || !n.name) return;
      const nKey = un(n.name);
      const fullKey = [...trail, nKey].join('|');
      // Lookup backend même chemin
      const matches = backendByNormalizedName.get(fullKey) || [];
      const backendNode = matches.find(b => un(b?.name) === nKey) || null;
      let next;
      if (backendNode) {
        next = { ...n, id: n.id || backendNode.id || genNodeId(), name: backendNode.name || n.name };
        // Récursion enfants
        next.children = walkStorage(n.children || [], [...trail, nKey]);
        // Ajouter les ENFANTS backend qu'il n'a pas
        if (backendNode.children?.length) {
          const existingNormalized = new Set((next.children || []).map(c => un(c?.name)));
          backendNode.children.forEach(bChild => {
            if (!existingNormalized.has(un(bChild?.name))) {
              // On doit re-walk depuis backend (sous-arbre entier manquant)
              next.children = next.children || [];
              const copySub = (src) => migrateNodeWithIds({ name: src.name, children: (src.children || []).map(copySub) });
              next.children.push(copySub(bChild));
            }
          });
        }
      } else {
        next = { ...n, id: n.id || genNodeId() };
        next.children = walkStorage(n.children || [], [...trail, nKey]);
      }
      outByName.set(fullKey, next);
    });
  };
  walkStorage(storageRoots || []);

  // 2) Parcours backend: ajouter les ROOT NOUVEAUX non présents en storage
  const storageRootsKeys = new Set((storageRoots || []).map(r => un(r?.name)));
  const result = [];
  const rootKeysDone = new Set();
  // Garder ordre storage d'abord
  (storageRoots || []).forEach(s => {
    const k = un(s?.name);
    const fullKey = k; // trail [] pour les roots
    if (outByName.has(fullKey) && !rootKeysDone.has(k)) {
      result.push(outByName.get(fullKey));
      rootKeysDone.add(k);
    }
  });
  (backendRoots || []).forEach(b => {
    const k = un(b?.name);
    if (!storageRootsKeys.has(k) && !rootKeysDone.has(k)) {
      const copySub = (src) => migrateNodeWithIds({ name: src.name, children: (src.children || []).map(copySub) });
      result.push(copySub(b));
      rootKeysDone.add(k);
    } else if (!rootKeysDone.has(k)) {
      if (outByName.has(k)) { result.push(outByName.get(k)); rootKeysDone.add(k); }
    }
  });
  return result;
};

// Merge les valeurs de facettes BACKEND dans TEMPLATES storage
const mergeTemplatesWithBackendFacets = (prevTemplates = {}, backendFacets = {}) => {
  const next = cloneTree(prevTemplates || {});
  if (!backendFacets || typeof backendFacets !== 'object') return next;
  Object.entries(backendFacets).forEach(([key, values]) => {
    if (!values || !Array.isArray(values) || values.length === 0) return;
    const existing = Array.isArray(next[key]) ? next[key].map(x => String(x).trim()).filter(Boolean) : [];
    const normExisting = new Set(existing.map(x => normalizeAdminName(x)));
    values.forEach(rawV => {
      const v = String(rawV || '').trim();
      if (!v) return;
      if (!normExisting.has(normalizeAdminName(v))) {
        existing.push(v);
        normExisting.add(normalizeAdminName(v));
      }
    });
    next[key] = existing;
  });
  return next;
};

const TreeNode = ({ node, onAddChildById, onRenameById, onDeleteById, level = 0 }) => {
  const isLeaf = !node.children || node.children.length === 0;
  const [editModal, setEditModal] = useState(false);
  const [editVal, setEditVal] = useState(node.name || '');
  const [addModal, setAddModal] = useState(false);
  const [addVal, setAddVal] = useState('');

  const accentColors = ['#0ea5e9', '#10b981', '#8b5cf6', '#f59e0b', '#ef4444', '#ec4899'];
  const accent = accentColors[level % accentColors.length];
  const nid = node.id;

  return (
    <Card
      size="small"
      variant="borderless"
      style={{
        marginTop: level === 0 ? 0 : 10,
        marginLeft: level * 16,
        borderRadius: 10,
        borderLeft: `4px solid ${accent}`,
        background: isLeaf ? 'linear-gradient(180deg, #f0fdf4 0%, #ffffff 100%)' : 'linear-gradient(180deg, #eff6ff 0%, #ffffff 100%)',
        boxShadow: '0 1px 2px rgba(15,23,42,0.06), 0 1px 3px rgba(15,23,42,0.04)'
      }}
      styles={{ body: { padding: '10px 12px' } }}
    >
      <Space wrap style={{ width: '100%', justifyContent: 'space-between' }} size={12}>
        <Space size={10} style={{ flex: 1, minWidth: 220 }}>
          {isLeaf ? (
            <Tag color="success" style={{ borderRadius: 999, padding: '2px 10px' }}><HomeOutlined /> FEUILLE</Tag>
          ) : (
            <Tag color="blue" style={{ borderRadius: 999, padding: '2px 10px' }}>
              <FolderOpenOutlined /> GROUPE <Badge size="small" count={countDirectChildren(node)} style={{ backgroundColor: '#1677ff' }} />
            </Tag>
          )}
          <Text strong style={{ fontSize: 14, letterSpacing: 0.2 }}>{node.name}</Text>
        </Space>
        <Space size={6} wrap>
          <Tooltip title="Renommer">
            <Button size="small" icon={<EditOutlined />} onClick={() => { setEditVal(node.name || ''); setEditModal(true); }}>Renommer</Button>
          </Tooltip>
          <Tooltip title="Ajouter un sous-élément (n'importe quel niveau)">
            <Button size="small" type="primary" ghost icon={<PlusSquareOutlined />} onClick={() => { setAddVal(''); setAddModal(true); }}>Ajouter enfant</Button>
          </Tooltip>
          <Popconfirm
            title={`Supprimer "${node.name}" ?`}
            description={isLeaf ? "Cette valeur sera retirée de l'organigramme." : `Tous les ${countLeaves(node)} éléments enfants seront aussi supprimés (irréversible).`}
            okText="Supprimer" cancelText="Annuler" okButtonProps={{ danger: true }}
            onConfirm={() => onDeleteById(nid)}
          >
            <Tooltip title="Supprimer ce nœud">
              <Button size="small" danger icon={<MinusSquareOutlined />}>Supprimer</Button>
            </Tooltip>
          </Popconfirm>
        </Space>
      </Space>

      {Array.isArray(node.children) && node.children.map((ch) => (
        <TreeNode
          key={ch.id || normalizeAdminName(ch?.name)}
          node={ch}
          level={level + 1}
          onAddChildById={onAddChildById}
          onRenameById={onRenameById}
          onDeleteById={onDeleteById}
        />
      ))}

      <Modal
        title={`✏️ Renommer "${node.name}"`}
        open={editModal} onCancel={() => setEditModal(false)}
        onOk={() => { const v = String(editVal || '').trim(); if (!v) return; onRenameById(nid, v); setEditModal(false); }}
        okText="Valider" cancelText="Annuler"
      >
        <Input value={editVal} onChange={e => setEditVal(e.target.value)} onPressEnter={() => { const v = String(editVal || '').trim(); if (v) { onRenameById(nid, v); setEditModal(false); } }} placeholder="Nouveau nom..." autoFocus />
      </Modal>
      <Modal
        title={`➕ Ajouter un enfant sous "${node.name}"`}
        open={addModal} onCancel={() => setAddModal(false)}
        onOk={() => { const v = String(addVal || '').trim(); if (!v) return; onAddChildById(nid, v); setAddModal(false); }}
        okText="Ajouter" cancelText="Annuler"
      >
        <Input value={addVal} onChange={e => setAddVal(e.target.value)} onPressEnter={() => { const v = String(addVal || '').trim(); if (v) { onAddChildById(nid, v); setAddModal(false); } }} placeholder="Ex: CAMÉRA THERMIQUE..." autoFocus />
        <div style={{ marginTop: 8 }}>
          <Text type="secondary" style={{ fontSize: 12 }}>💡 Conseil : pour ajouter une SOUS-FAMILLE (groupe avec enfants), cliquez sur le bouton "Ajouter enfant" de ce nouveau nœud après l'avoir créé.</Text>
        </div>
      </Modal>
    </Card>
  );
};

const AdminFilters = () => {
  const { message: appMsg, modal: appModal } = App.useApp();
  const initial = useMemo(() => loadAll(), []);
  const [templates, setTemplates] = useState(initial.templates);
  const [familyTree, setFamilyTree] = useState(initial.familyTree);
  const [edits, setEdits] = useState({});
  const [dirty, setDirty] = useState(false);
  const [addFamModal, setAddFamModal] = useState(false);
  const [addFamVal, setAddFamVal] = useState('');
  const [activeFamKeys, setActiveFamKeys] = useState(() => familyTree.map(f => String(f.id)));
  const [openFamilies, setOpenFamilies] = useState(() => new Set(familyTree.map(f => String(f.id))));

  useEffect(() => {
    const initialEdits = {};
    Object.keys(templates).forEach(k => { initialEdits[k] = ''; });
    setEdits(prev => ({ ...initialEdits, ...prev }));
  }, []);

  // ========== 🔁 SYNCHRO AUTO BDD → STORAGE (familles + facettes) ==========
  const [syncing, setSyncing] = useState(false);
  const [syncCount, setSyncCount] = useState(0);
  const syncFromBackend = async ({ silent = true } = {}) => {
    if (typeof window === 'undefined') return;
    try {
      setSyncing(true);
      const res = await categoryService.getCategories({ includeInactive: false });
      const flatCats = Array.isArray(res?.categories) ? res.categories : [];
      const backendTree = buildTreeFromFlatCategories(flatCats);
      const facetsRes = await productService.getProductFacets({});
      const backendFacets = facetsRes?.facets || {};

      // Merge: STORAGE PRIORITY (custom manuels conservés) + BDD ajoute nouveaux nœuds
      let mergedTree = mergeBackendIntoStorageTree(familyTree || [], backendTree);
      // Si storage arbre VIDE (1ère utilisation): fallback sur backend
      if (!mergedTree || mergedTree.length === 0) mergedTree = backendTree.map(n => migrateNodeWithIds({ name: n.name, children: (n.children || []).map(function copySub(s){ return migrateNodeWithIds({ name: s.name, children: (s.children||[]).map(copySub) }); }) }));

      const mergedTemplates = mergeTemplatesWithBackendFacets(templates || {}, backendFacets);

      // Mettre à jour state UI
      setFamilyTree(mergedTree);
      setTemplates(mergedTemplates);
      // Mettre à jour storage global (window + sessionStorage + localStorage + broadcast cross-tab)
      persist(mergedTemplates, mergedTree);
      // Mettre à jour openFamilies
      setOpenFamilies(new Set(mergedTree.map(f => String(f.id))));
      setActiveFamKeys(mergedTree.map(f => String(f.id)));
      setSyncCount(v => v + 1);
      if (!silent) appMsg.success(`✅ Synchronisé depuis la base: ${flatCats.length} catégories`);
    } catch (e) {
      if (!silent) appMsg.error('❌ Erreur synchro BDD: ' + (e?.message || 'inconnu'));
    } finally { setSyncing(false); }
  };

  // 1) AU DEMARRAGE : sync immédiate
  useEffect(() => { syncFromBackend({ silent: true }); /* eslint-disable-next-line */ }, []);
  // 2) POLLING AUTO: toutes les 12 SECONDES (nouvelles familles/valeurs importées via Excel → apparition auto)
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const iv = setInterval(() => syncFromBackend({ silent: true }), 12000);
    return () => clearInterval(iv);
    // eslint-disable-next-line
  }, []);
  // =============================================================================

  // --- Lecture / Écriture partagée multi-support :
  //     1) window.__domoelecFiltersStore (RAM globale, fonctionne MÊME SI Tracking Prevention bloque)
  //     2) sessionStorage (moins sujet au Tracking Prevention que localStorage)
  //     3) localStorage (encore tenté en fallback si autorisé)
  //     4) BroadcastChannel cross-tab (pour synchronisation ENTRE onglets sans storage)
  const writeSharedStore = (tpl, ft) => {
    const payload = { templates: tpl, familyTree: ft, ts: Date.now() };
    try { window.__domoelecFiltersStore = payload; } catch { /* ignore */ }
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload)); } catch { /* ignore Tracking Prevention */ }
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(payload)); } catch { /* ignore Tracking Prevention */ }
    try {
      if (!window.__domoelecFiltersBroadcast) {
        try { window.__domoelecFiltersBroadcast = new BroadcastChannel('domoelec-filters-channel'); }
        catch { window.__domoelecFiltersBroadcast = null; }
      }
      if (window.__domoelecFiltersBroadcast) {
        try { window.__domoelecFiltersBroadcast.postMessage({ type: 'filters-updated', payload }); } catch { /* ignore */ }
      }
    } catch { /* ignore */ }
  };

  const persist = (tpl, ft) => {
    try {
      writeSharedStore(tpl, ft);
      try {
        window.dispatchEvent(new CustomEvent('domoelec:filters-updated', { detail: { templates: tpl, familyTree: ft } }));
      } catch { /* ignore old browsers */ }
    }
    catch { /* ignore */ }
  };
  const markDirty = () => setDirty(true);

  /* ===== Facettes 17 ===== */
  const addFacetValue = (key) => {
    const v = String(edits[key] || '').trim();
    if (!v) return;
    const facetLabel = FACET_BY_KEY[key] || FACET_DEFS.find(f => f.k === key)?.label || key;
    const existing = Array.isArray(templates[key]) ? [...templates[key]] : [];
    if (existing.map(x => String(x).toUpperCase()).includes(v.toUpperCase())) {
      appMsg.warning(`"${v}" existe déjà dans ${facetLabel}`);
      return;
    }
    existing.push(v);
    const next = { ...templates, [key]: existing };
    setTemplates(next); persist(next, familyTree);
    setEdits(prev => ({ ...prev, [key]: '' }));
    markDirty();
    appMsg.success(`✅ "${v}" ajouté dans ${facetLabel}`);
  };
  const removeFacetValue = (key, value) => {
    const facetLabel = FACET_BY_KEY[key] || FACET_DEFS.find(f => f.k === key)?.label || key;
    const existing = (templates[key] || []).filter(x => x !== value);
    const next = { ...templates, [key]: existing };
    setTemplates(next); persist(next, familyTree);
    markDirty();
    appMsg.success(`🗑️ "${value}" retiré de ${facetLabel}`);
  };

  /* ===== FAMILIES ===== */
  const addFamily = name => {
    const v = String(name || '').trim();
    if (!v) { appMsg.warning('Nom de famille vide interdit'); return false; }
    const upper = normalizeAdminName(v);
    if (familyTree.some(f => normalizeAdminName(f?.name) === upper)) {
      appMsg.warning(`Famille "${v}" existe déjà (doublon)`);
      return false;
    }
    const newNode = migrateNodeWithIds({ name: v, children: [] });
    const next = [...familyTree, newNode];
    setFamilyTree(next); persist(templates, next); markDirty();
    appMsg.success(`✅ Famille "${v}" ajoutée`);
    return true;
  };

  const renameById = (targetId, newName) => {
    const v = String(newName || '').trim();
    if (!v) { appMsg.warning('Nom vide interdit'); return; }
    const upper = normalizeAdminName(v);
    const refInCurrent = findInTreeById(familyTree, targetId);
    if (!refInCurrent) return;
    const oldName = refInCurrent.node.name;
    if (normalizeAdminName(oldName) === upper) return;
    // Doublon frère
    const siblings = refInCurrent.parent;
    const hasDup = siblings.some(s => s && s.id !== targetId && normalizeAdminName(s.name) === upper);
    if (hasDup) { appMsg.warning(`"${v}" existe déjà au même niveau (doublon)`); return; }
    const next = cloneTree(familyTree);
    const ref = findInTreeById(next, targetId);
    if (!ref) return;
    ref.node.name = v;
    setFamilyTree(next); persist(templates, next); markDirty();
    appMsg.success(`✏️ "${oldName}" renommé en "${v}"`);
  };

  const addChildById = (parentId, childName) => {
    const v = String(childName || '').trim();
    if (!v) { appMsg.warning('Nom vide interdit'); return; }
    const upper = normalizeAdminName(v);
    const refParentCurrent = findInTreeById(familyTree, parentId);
    if (!refParentCurrent) return;
    const parentName = refParentCurrent.node.name;
    const siblings = refParentCurrent.node.children || [];
    if (siblings.some(c => normalizeAdminName(c?.name) === upper)) {
      appMsg.warning(`"${v}" existe déjà sous "${parentName}" (doublon)`); return;
    }
    const next = cloneTree(familyTree);
    const ref = findInTreeById(next, parentId);
    if (!ref) return;
    if (!Array.isArray(ref.node.children)) ref.node.children = [];
    ref.node.children.push(migrateNodeWithIds({ name: v, children: [] }));
    setFamilyTree(next); persist(templates, next); markDirty();
    appMsg.success(`✅ "${v}" ajouté sous "${parentName}"`);
  };

  const deleteById = (targetId) => {
    const refCur = findInTreeById(familyTree, targetId);
    if (!refCur) return;
    const removedName = refCur.node.name;
    const next = cloneTree(familyTree);
    const ref = findInTreeById(next, targetId);
    if (!ref) return;
    ref.parent.splice(ref.index, 1);
    setFamilyTree(next); persist(templates, next); markDirty();
    appMsg.success(`🗑️ "${removedName}" supprimé`);
  };

  /* ===== Globales ===== */
  const resetAll = () => {
    appModal.confirm({
      title: 'Tout réinitialiser ?',
      content: '✅ Facettes (17 listes plates) + ✅ 10 organigrammes familles reviennent aux valeurs par défaut officielles. Vos modifications sont perdues.',
      okText: 'Réinitialiser', cancelText: 'Annuler', okButtonProps: { danger: true },
      onOk: () => {
        const nextTpl = cloneTree(DEFAULT_TEMPLATES);
        const nextFt = migrateTreeWithIds(DEFAULT_FAMILY_TREE);
        setTemplates(nextTpl); setFamilyTree(nextFt);
        persist(nextTpl, nextFt);
        markDirty();
        appMsg.success('Valeurs par défaut restaurées (facettes + familles)');
      }
    });
  };
  const saveAll = () => { persist(templates, familyTree); setDirty(false); appMsg.success('✅ Filtres & Organigrammes enregistrés'); };

  const totalLeavesAll = familyTree.reduce((sum, f) => sum + countLeaves(f), 0);
  const totalDirectChildren = familyTree.reduce((sum, f) => sum + countDirectChildren(f), 0);
  const totalFacetsVals = FACET_DEFS.reduce((sum, f) => sum + Math.max(0, (templates[f.k] || []).length), 0);

  const [activeTab, setActiveTab] = useState('families');
  const collapseWrapperRef = React.useRef(null);

  const toggleFamily = (id) => {
    const key = String(id);
    setOpenFamilies(prev => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };
  const expandAllFamilies = () => {
    if (!Array.isArray(familyTree)) return;
    setOpenFamilies(new Set(familyTree.map(f => String(f.id))));
  };
  const collapseAllFamilies = () => setOpenFamilies(new Set());

  const renderFamiliesSection = () => (
    <div>
      <Flex wrap="wrap" gap={12} align="center" style={{ width: '100%', marginBottom: 20 }}>
        <Button type="primary" size="large" icon={<PlusOutlined />} onClick={() => { setAddFamVal(''); setAddFamModal(true); }}>
          ➕ Ajouter une nouvelle FAMILLE
        </Button>
        <Space wrap size={8} style={{ flex: 1, minWidth: 280, justifyContent: 'flex-end' }}>
          <Tag icon={<HomeOutlined />} color="green" style={{ borderRadius: 999, padding: '4px 12px' }}>{totalLeavesAll} feuilles</Tag>
          <Tag icon={<AppstoreOutlined />} color="blue" style={{ borderRadius: 999, padding: '4px 12px' }}>{totalDirectChildren} sous-groupes directs</Tag>
        </Space>
      </Flex>

      <Flex justify="space-between" align="center" wrap="wrap" gap={10} style={{ marginBottom: 14 }}>
        <Text type="secondary">Conseil : Chaque famille contient des SOUS-GROUPES et enfin des <Tag color="green">FEUILLES vertes</Tag> = emplacements des produits.</Text>
        <Space size={8}>
          <Button size="middle" onClick={expandAllFamilies} icon={<DownOutlined />}>⬇️ Développer tout</Button>
          <Button size="middle" onClick={collapseAllFamilies} icon={<UpOutlined />}>⬆️ Réduire tout</Button>
        </Space>
      </Flex>

      {familyTree.length === 0 ? (
        <Empty description="Aucune famille. Cliquez sur « Ajouter une famille »." />
      ) : (
        <div ref={collapseWrapperRef} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {familyTree.map((fam) => {
            const fid = String(fam.id);
            const isOpen = openFamilies.has(fid);
            const leafCount = countLeaves(fam);
            const directCount = countDirectChildren(fam);
            const gradient = 'linear-gradient(135deg, #f8fafc 0%, #ffffff 45%, #ffffff 100%)';
            return (
              <Card
                key={fid}
                size="large"
                styles={{ body: { padding: 0, borderRadius: 14, overflow: 'hidden' } }}
                style={{
                  background: gradient,
                  borderRadius: 14,
                  border: '1px solid #e2e8f0',
                  boxShadow: isOpen ? '0 4px 18px rgba(15,23,42,0.07)' : '0 1px 3px rgba(15,23,42,0.05)'
                }}
              >
                {/* HEADER CLICKABLE (toggle) */}
                <div
                  onClick={() => toggleFamily(fid)}
                  style={{
                    padding: '16px 20px',
                    cursor: 'pointer',
                    userSelect: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 14,
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    borderBottom: isOpen ? '1px solid #e2e8f0' : 'none',
                    background: isOpen ? 'linear-gradient(90deg, #eff6ff 0%, #ffffff 100%)' : 'transparent'
                  }}
                >
                  <Space wrap size={12} style={{ flex: 1, minWidth: 260 }}>
                    <div
                      style={{
                        width: 34, height: 34, borderRadius: 10,
                        background: 'linear-gradient(135deg, #3b82f6 0%, #0ea5e9 100%)',
                        color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 18, flexShrink: 0,
                        boxShadow: '0 4px 10px rgba(59,130,246,0.25)'
                      }}
                    >🏠</div>
                    <Title level={5} style={{ margin: 0, fontSize: 16 }}>
                      <span style={{ letterSpacing: 0.3 }}>{fam.name}</span>
                    </Title>
                    <Space size={6}>
                      <Tag color="green" style={{ borderRadius: 999, padding: '2px 10px' }}>🍃 {leafCount}</Tag>
                      <Tag color="blue" style={{ borderRadius: 999, padding: '2px 10px' }}>📁 {directCount}</Tag>
                    </Space>
                  </Space>
                  <Space size={10} align="center">
                    {/* Zone Action — pas de toggle */}
                    <div onClick={e => { if (e && typeof e.stopPropagation === 'function') e.stopPropagation(); }}>
                      <Space size={6}>
                        <Button size="small" icon={<EditOutlined />} onClick={() => {
                          const val = { current: fam.name || '' };
                          appModal.confirm({
                            title: `✏️ Renommer famille "${fam.name}"`,
                            content: (
                              <Input defaultValue={fam.name} onChange={e => { val.current = e.target.value; }} placeholder="Nouveau nom famille" />
                            ),
                            onOk: () => renameById(fam.id, val.current),
                            okText: 'Valider', cancelText: 'Annuler'
                          });
                        }}>Renommer</Button>
                        <Popconfirm
                          title={`Supprimer la famille "${fam.name}" ?`}
                          description={`${leafCount} feuille(s) au total vont être supprimées de l'organigramme.`}
                          okText="Supprimer famille" cancelText="Annuler" okButtonProps={{ danger: true }}
                          onConfirm={() => deleteById(fam.id)}
                        >
                          <Button size="small" danger>Supprimer famille</Button>
                        </Popconfirm>
                      </Space>
                    </div>
                    {/* Chevron toggle */}
                    <div
                      style={{
                        width: 30, height: 30, borderRadius: 8,
                        background: '#f1f5f9', color: '#475569',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 14, fontWeight: 700,
                        transition: 'transform 0.2s ease',
                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                      }}
                    >
                      ▼
                    </div>
                  </Space>
                </div>

                {/* BODY expandable */}
                {isOpen && (
                  <div style={{ padding: '18px 20px 22px' }}>
                    <Space.Compact block style={{ marginBottom: 16 }}>
                      <Input
                        size="large"
                        placeholder={`Ajouter un PREMIER NIVEAU sous ${fam.name} (ex: CATÉGORIE, MARQUE, NORME...)`}
                        onPressEnter={e => { const v = String(e.target.value || '').trim(); if (v) { addChildById(fam.id, v); e.target.value = ''; } }}
                      />
                      <Button
                        size="large"
                        type="primary" icon={<PlusOutlined />}
                        onClick={e => {
                          const input = e.currentTarget.closest('.ant-space-compact')?.querySelector('input');
                          if (!input) return;
                          const v = String(input.value || '').trim(); if (v) { addChildById(fam.id, v); input.value = ''; }
                        }}
                      >
                        Ajouter SOUS-GROUPE/VALEUR
                      </Button>
                    </Space.Compact>

                    {Array.isArray(fam.children) && fam.children.length > 0 ? fam.children.map((ch) => (
                      <TreeNode
                        key={ch.id || normalizeAdminName(ch?.name)}
                        node={ch}
                        level={1}
                        onAddChildById={addChildById}
                        onRenameById={renameById}
                        onDeleteById={deleteById}
                      />
                    )) : (
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="Aucun enfant — ajoutez un MARQUE / CATÉGORIE / TYPE..."
                        style={{ padding: 12 }}
                      />
                    )}
                  </div>
                )}
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );

  const renderFacetsSection = () => (
    <div>
      <Flex wrap="wrap" gap={10} align="center" justify="space-between" style={{ width: '100%', marginBottom: 16 }}>
        <Text style={{ fontSize: 14, fontWeight: 500, letterSpacing: 0.3 }}>
          {FACET_DEFS.length} listes • {totalFacetsVals} valeurs au total
        </Text>
        <Text type="secondary">Les valeurs apparaissent en temps réel dans le formulaire Produits.</Text>
      </Flex>

      <Row gutter={[16, 24]}>
        {FACET_DEFS.map((facet, idx) => {
          const vals = Array.isArray(templates[facet.k]) ? templates[facet.k] : [];
          const palette = [
            { card: '#eff6ff', accent: '#2563eb', border: '#bfdbfe' },
            { card: '#f0fdf4', accent: '#16a34a', border: '#bbf7d0' },
            { card: '#fefce8', accent: '#ca8a04', border: '#fde68a' },
            { card: '#fdf4ff', accent: '#a855f7', border: '#f5d0fe' },
            { card: '#f0f9ff', accent: '#0284c7', border: '#bae6fd' },
            { card: '#fff7ed', accent: '#ea580c', border: '#fed7aa' },
            { card: '#fef2f2', accent: '#dc2626', border: '#fecaca' },
            { card: '#ecfeff', accent: '#0891b2', border: '#a5f3fc' },
          ];
          const p = palette[idx % palette.length];
          return (
            <Col xs={24} sm={12} md={8} lg={6} key={facet.k}>
              <Card
                size="small"
                variant="outlined"
                styles={{ body: { padding: 16, minHeight: 240, height: '100%' } }}
                style={{
                  borderRadius: 12,
                  background: `linear-gradient(180deg, ${p.card} 0%, #ffffff 55%)`,
                  border: `1px solid ${p.border}`,
                  boxShadow: '0 1px 2px rgba(15,23,42,0.05), 0 1px 3px rgba(15,23,42,0.03)'
                }}
                title={
                  <Space size={10}>
                    <span style={{ color: p.accent, fontSize: 16 }}>●</span>
                    <strong style={{ letterSpacing: 0.3 }}>{facet.label}</strong>
                    <Badge
                      count={vals.length}
                      showZero
                      style={{ backgroundColor: p.accent, boxShadow: '0 0 0 1px #fff' }}
                      offset={[2, 2]}
                    />
                  </Space>
                }
                extra={<Text type="secondary" style={{ fontSize: 12 }}>{facet.k}</Text>}
              >
                <Space.Compact style={{ width: '100%', marginBottom: 12 }}>
                  <Input
                    placeholder={`Ajouter une valeur "${facet.label}"...`}
                    value={edits[facet.k] ?? ''}
                    onChange={e => setEdits(prev => ({ ...prev, [facet.k]: e.target.value }))}
                    onPressEnter={() => addFacetValue(facet.k)}
                  />
                  <Tooltip title={`Ajouter à ${facet.label}`}>
                    <Button type="primary" icon={<PlusOutlined />} onClick={() => addFacetValue(facet.k)} style={{ background: p.accent, borderColor: p.accent }}>
                      Ajouter
                    </Button>
                  </Tooltip>
                </Space.Compact>

                {vals.length === 0 ? (
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Aucune valeur" style={{ padding: 12 }} />
                ) : (
                  <Flex wrap="wrap" gap={[6, 6]} style={{ marginTop: 2 }}>
                    {vals.map(v => (
                      <Tag
                        key={String(v)}
                        closable
                        onClose={e => { e.preventDefault(); removeFacetValue(facet.k, v); }}
                        style={{
                          padding: '4px 12px',
                          margin: 2,
                          borderRadius: 999,
                          background: p.card,
                          border: `1px solid ${p.border}`,
                          color: p.accent,
                          fontWeight: 500
                        }}
                      >
                        {String(v)}
                      </Tag>
                    ))}
                  </Flex>
                )}
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );

  return (
    <div style={{ padding: 16 }}>
      <Card
        style={{ borderRadius: 14, boxShadow: '0 1px 3px rgba(15,23,42,0.06), 0 8px 24px rgba(15,23,42,0.04)' }}
        styles={{ body: { padding: 24 } }}
      >
        <Flex justify="space-between" align="flex-start" wrap="wrap" gap={14} style={{ width: '100%', marginBottom: 16 }}>
          <div style={{ minWidth: 280, flex: 1, flexBasis: 300, maxWidth: '100%' }}>
            <Title level={3} style={{ margin: 0, letterSpacing: 0.2 }}>
              🔧 Filtres & Organigrammes produit
            </Title>
            <Text type="secondary" style={{ display: 'block', marginTop: 6 }}>
              Modifiez ici les <strong>{familyTree.length} organigrammes familles</strong> + leurs enfants (section 🏠) ET les <strong>{FACET_DEFS.length} listes de facettes</strong> (section 🧩).
              Toutes les valeurs apparaissent en temps réel dans le formulaire Produits.
            </Text>
          </div>
          <Flex wrap="wrap" gap={10} align="flex-start">
            <Button icon={<ReloadOutlined />} onClick={resetAll} danger ghost>Revenir aux valeurs par défaut</Button>
            <Tooltip title={dirty ? "Enregistrer les modifications" : "Aucune modification en attente"}>
              <Button type="primary" size="large" icon={<SaveOutlined />} onClick={saveAll} disabled={!dirty}>
                💾 Enregistrer{dirty ? ' (modifications en attente)' : ''}
              </Button>
            </Tooltip>
          </Flex>
        </Flex>

        <Divider style={{ margin: '0 0 20px' }} />

        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          size="large"
          centered
          items={[
            {
              key: 'families',
              label: '🏠 FAMILLES & Organigrammes',
              children: renderFamiliesSection()
            },
            {
              key: 'facets',
              label: '🧩 FACETTES prédéfinies',
              children: renderFacetsSection()
            }
          ]}
          tabBarStyle={{
            background: 'linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)',
            borderRadius: 12,
            padding: '4px 8px 0',
            border: '1px solid #e2e8f0'
          }}
        />

        <Modal
          title="➕ Ajouter une nouvelle FAMILLE (racine)"
          open={addFamModal} onCancel={() => setAddFamModal(false)}
          onOk={() => { if (addFamily(addFamVal)) setAddFamModal(false); }}
          okText="Créer la famille" cancelText="Annuler"
        >
          <Input value={addFamVal} onChange={e => setAddFamVal(e.target.value)}
            onPressEnter={() => { if (addFamily(addFamVal)) setAddFamModal(false); }}
            placeholder="Ex: ALARMES INCENDIE, STOCKAGE ENERGIE..." autoFocus />
          <div style={{ marginTop: 8 }}>
            <Text type="secondary" style={{ fontSize: 12 }}>⚠️ Une famille est une RACINE de l'organigramme. Si vous voulez ajouter une SOUS-CATÉGORIE, utilisez plutôt le bouton Ajouter enfant de la famille ou sous-groupe correspondant.</Text>
          </div>
        </Modal>
      </Card>
    </div>
  );
};

export default AdminFilters;
